import loadPolyfills from '../brighteon/load_polyfills';
import { start } from '../brighteon/common';

start();

function loaded() {
  const UnsignedNavigationContainer = require('../brighteon/containers/unsigned_navigation_container').default;
  const React = require('react');
  const ReactDOM = require('react-dom');
  const mountNode = document.getElementById('brighteon-unsigned-navigation');

  if (mountNode !== null) {
    const props = JSON.parse(mountNode.getAttribute('data-props'));
    ReactDOM.render(<UnsignedNavigationContainer {...props} />, mountNode);
  }
}

function main() {
  const ready = require('../brighteon/ready').default;
  ready(loaded);
}

loadPolyfills().then(main).catch(error => {
  console.error(error);
});
